import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingImageSharpenerConfig } from '@/data/landingConfig/landingImageSharpenerConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_ImageSharpener } from './schemaObject';

interface Props {}
const ImageSharpener: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_ImageSharpener} />
			<LandingTemplate
				data={landingImageSharpenerConfig}
				funnelLinkService={GenerateLandingLinkService.funnelImageEnhancementV2()}
			/>
		</>
	);
};

export default ImageSharpener;
